import MyDocumentsServices from "./MyDocumentsServices";
import MyDocumentsServicesMock from "./MyDocumentsServicesMock";

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? MyDocumentsServicesMock : MyDocumentsServices;